<template>
  <div id="legislations-page">
    <b-row :style="tituloRowBG" class="tituloPaginaRow">
      <h1 class="tituloPagina text-center tituloIntro">
        {{ tituloPagina }}
      </h1>
    </b-row>
    <b-row class="p-3 p-sm-0">
      <b-col cols="12">
        <!-- Selecao periodo -->
        <div id="arvore">
          <div id="decades-row">
            <div id="decades">
              <div v-for="(decade, index) in decades" :key="index">
                <b-button
                  type="button"
                  class="periodButton"
                  :class="decade.activeMenu ? 'menu-active' : ''"
                  variant="cinzaClaro"
                  @click="loadYears(decade)"
                  :id="decade.id"
                  >{{ decade.title }}</b-button
                >
              </div>
            </div>
          </div>
          <div id="years-row">
            <div id="years">
              <div v-for="(year, index) in years" :key="index">
                <b-button
                  type="button"
                  class="periodButton"
                  :class="year.activeMenu ? 'menu-active' : ''"
                  variant="cinzaClaro"
                  @click="loadMonths(year)"
                  :id="year.id"
                  >Ano {{ year.title }}</b-button
                >
              </div>
            </div>
          </div>
          <div id="months-row">
            <div id="months">
              <div v-for="(month, index) in months" :key="index">
                <b-button
                  type="button"
                  class="periodButton"
                  :class="month.activeMenu ? 'menu-active' : ''"
                  variant="cinzaClaro"
                  @click="loadLegislations(month, index)"
                  :id="month.id"
                  name="button"
                  >{{ month.title }}</b-button
                >
              </div>
            </div>
          </div>
          <div id="types-row">
            <div id="types">
              <div v-for="(type, index) in types" :key="index">
                <b-button
                  type="button"
                  :class="type.activeMenu ? 'menu-active' : ''"
                  variant="cinzaClaro"
                  @click="loadType(type, true)"
                  :id="type.id"
                  name="button"
                  >{{ type.title }}</b-button
                >
              </div>
              <template v-if="typeSelected">
                <div>
                  <b-button
                    type="button"
                    variant="cinzaClaro"
                    @click="resetTypes()"
                    name="button"
                  >
                    <icon name="times"></icon>&nbsp;&nbsp;Limpar
                  </b-button>
                </div>
              </template>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row class="text-center">
      <b-col cols="12" sm="12" md="12" lg="12" xl="12" class="mt-sm-2 mb-sm-8">
        <!-- Tabela Legislações -->
        <template v-if="legislationsLoaded && !legislationIsLoading">
          <template v-if="items.length">
            <div class="tipo-legislations">
              <strong
                >Mês Selecionado:
                <i class="themecolor"
                  >{{ activeMonthName }} de {{ activeYearName }}</i
                ></strong
              >
              <template v-if="typeSelected">
                <br />
                <strong
                  >Tipo Selecionado:
                  <i class="themecolor">{{ activeTypeName }}</i></strong
                >
              </template>
            </div>
            <h4 class="text-center mt-4">Publicações</h4>
            <b-table
              striped
              hover
              :items="items"
              :fields="fields"
              :per-page="perPage"
              id="tableLegislations"
            >
              <template v-slot:cell(type)="data">
                {{ data.item['type'] }} {{ data.item['number'] }}
              </template>
              <template v-slot:cell(publication_date)="data">
                {{ data.item['publication_date'] | formatDate }}
              </template>
              <template v-slot:cell(epigrafe)="data">
                {{ data.item['epigrafe'] | formatEpigrafe }}
              </template>
              <template v-slot:cell(downloads)="data">
                {{ data.item['downloads'] | formatViews }}
              </template>
              <template v-slot:cell(acoes)="data">
                <b-link
                  target="_blank"
                  :href="viewLegislation(data.item.edition.id, data.item.page)"
                  v-b-tooltip.hover
                  title="Ver legislação"
                >
                  <icon name="eye"></icon>
                </b-link>
                <b-link
                  :href="downloadLegislation(data.item.edition.id)"
                  v-b-tooltip.hover
                  title="Baixar legislação"
                >
                  <icon name="download"></icon>
                </b-link>
              </template>
            </b-table>
            <nav>
              <b-pagination
                class="d-inline-flex"
                :total-rows="totalRows"
                :per-page="perPage"
                v-model="currentPage"
                @input="changePage"
                prev-text="Anterior"
                next-text="Próximo"
                hide-goto-end-buttons
              />
            </nav>
          </template>
          <div v-else class="message">
            <strong
              >Não existem legislações publicadas nesse mês, por favor selecione
              outra data.</strong
            >
          </div>
        </template>
        <template v-else-if="legislationIsLoading">
          <div class="message">
            <strong>
              Carregando listagem
              <icon name="spinner" spin></icon>
            </strong>
          </div>
        </template>
        <template v-else>
          <div class="message">
            <strong
              >Selecione acima a data da legislação para a exibição da
              listagem</strong
            >
          </div>
        </template>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import axios from 'axios'
  import moment from 'moment'
  import 'moment/locale/pt-br'
  import PortalApi from '@/api/portal'
  import client from '@/main.js'

  export default {
    data() {
      return {
        client: null,
        perPage: 10,
        tituloPagina: 'Todas as legislações',
        decades: [],
        years: null,
        yearsMock: [],
        months: null,
        monthsMock: [],
        types: null,
        currentDecade: null,
        firstDecade: null,
        firstYear: null,
        firstMonth: null,
        currentYear: null,
        currentMonth: null,
        legislations: null,
        activeYear: null,
        activeYearName: null,
        activeMonthData: null,
        activeMonthName: null,
        activeTypeData: null,
        legislationsLoaded: false,
        legislationIsLoading: false,
        typeSelected: false,
        activeTypeName: null,
        totalDecades: null,
        fields: [
          {
            key: 'type',
            label: 'Título',
            sortable: false
          },
          {
            key: 'publication_date',
            label: 'Data da publicação',
            sortable: false
          },
          {
            key: 'epigrafe',
            label: 'Epígrafe',
            sortable: false,
            class: 'colEpigrafe'
          },
          {
            key: 'acoes',
            label: 'Ações',
            class: 'text-center acoes'
          }
        ],
        items: [],
        currentPage: 1,
        totalRows: 0
      }
    },
    created() {
      let me = this
      me.fetchDecades()
      me.client = client.CLIENT
      me.tituloRowBG = {
        backgroundImage:
          'url(' +
          require('@/assets/imagens/' + me.client + '/tituloPagFdo.png') +
          ')'
      }
    },
    methods: {
      fetchDecades() {
        if (process.env.LEGISLATIONS_FIRST_YEAR === undefined) {
          // console.error('LEGISLATIONS_FIRST_YEAR não configurado no ambiente, favor configurar no .env')
          return
        }
        let me = this
        const dataIni = moment(process.env.LEGISLATIONS_FIRST_YEAR)
        const dataEnd = moment()
        let firstYear = moment.utc(dataIni).year()
        let currentYear = dataEnd.year()
        let firstDecade = me.getDecadesFromYear(firstYear)
        me.firstDecade = firstDecade
        me.firstYear = firstYear
        me.firstMonth = moment.utc(dataIni).month() + 1
        me.currentMonth = moment().month() + 1
        me.currentYear = currentYear
        me.currentDecade = me.getDecadesFromYear(currentYear)
        me.totalDecades = parseInt((currentYear - firstDecade) / 10)
        me.createDecades()
      },
      getDecadesFromYear(year) {
        if (
          Number.isNaN(year) ||
          year.toString().length < 4 ||
          year.toString().length > 4
        ) {
          throw new Error(
            'Date must be valid and have a 4-digit year attribute'
          )
        }
        let start = parseInt(Number(year) / 10) * 10
        return start
      },
      createDecades() {
        let me = this
        for (let i = 0; i <= me.totalDecades; i++) {
          me.decades.push({
            id: i,
            decade: me.nameDecades(i),
            title: 'Anos ' + me.nameDecades(i)
          })
        }
      },
      nameDecades(ind) {
        let me = this
        return 2020 - (me.totalDecades - ind) * 10
      },
      mockYears(item) {
        let me = this

        let thisDecade = item.decade

        let firstYear = item.decade
        let endYear = item.decade + 9

        if (thisDecade === me.firstDecade) {
          firstYear = me.firstYear
        }

        if (thisDecade === me.currentDecade) {
          endYear = me.currentYear
        }

        me.yearsMock = []

        for (let i = firstYear; i <= endYear; i++) {
          me.yearsMock.push({
            id: i,
            title: i
          })
        }
      },
      loadYears(item) {
        let me = this
        me.mockYears(item)
        me.years = me.yearsMock
        me.activeYear = null
        me.activeYearName = null
        me.activeMonthName = null
        me.months = null
        me.types = null
        me.legislations = null
        me.legislationsLoaded = false
        me.clearDecades()
        item.activeMenu = true
      },
      nameMonths(ind) {
        let monthName = ''
        let monthInd = ind.toString()
        switch (monthInd) {
          case '1':
            monthName = 'Janeiro'
            break
          case '2':
            monthName = 'Fevereiro'
            break
          case '3':
            monthName = 'Março'
            break
          case '4':
            monthName = 'Abril'
            break
          case '5':
            monthName = 'Maio'
            break
          case '6':
            monthName = 'Junho'
            break
          case '7':
            monthName = 'Julho'
            break
          case '8':
            monthName = 'Agosto'
            break
          case '9':
            monthName = 'Setembro'
            break
          case '10':
            monthName = 'Outubro'
            break
          case '11':
            monthName = 'Novembro'
            break
          case '12':
            monthName = 'Dezembro'
            break
          default:
            monthName = 'Erro'
        }
        return monthName
      },
      mockMonths(item) {
        let me = this
        let thisYear = item.id

        let startMonth = 1
        let endMonth = 12

        if (thisYear === me.firstYear) {
          startMonth = me.firstMonth
        }

        if (thisYear === me.currentYear) {
          endMonth = me.currentMonth
        }

        me.monthsMock = []

        for (let i = startMonth; i <= endMonth; i++) {
          me.monthsMock.push({
            // id: '0' + i,
            id: i,
            title: me.nameMonths(i)
          })
        }
      },
      loadTypes(item) {
        let me = this
        let typesData = []
        let typesInd = Object.keys(item)
        let start = 1

        for (var i = 0; i < typesInd.length; i++) {
          typesData.push({
            id: Object.keys(item)[i],
            title: item[start]
          })
          start++
        }

        me.types = typesData
      },
      loadMonths(item) {
        let me = this
        me.legislations = null
        me.types = null
        me.legislationsLoaded = false
        me.activeYear = item.id
        me.activeYearName = item.title
        me.activeMonthName = null
        me.mockMonths(item)
        me.months = me.monthsMock
        me.clearYears()
        item.activeMenu = true
      },
      loadType(item, typeChanged, page = 1) {
        let me = this
        me.legislationIsLoading = true
        me.activeTypeData = item
        me.clearTypes()
        item.activeMenu = true
        me.activeTypeName = item.title
        if (typeChanged) {
          me.currentPage = 1
        }
        me.typeSelected = true
        me.items = []

        let activeMonth = me.activeMonthData.ind + 1
        let activeType = item.id
        const promisse = PortalApi.fetchSelectedLegislationsByType(
          me.activeYear,
          activeMonth,
          activeType,
          page,
          me.perPage
        )
        promisse.then((items) => {
          me.items = items.legislations.data
          me.totalRows = items.legislations.total
          me.legislationIsLoading = false
          me.legislationsLoaded = true
        })
      },
      clearDecades() {
        let me = this
        for (let i = 0; i < me.decades.length; i++) {
          if (me.decades[i].activeMenu === true)
            me.decades[i].activeMenu = false
        }
      },
      clearYears() {
        let me = this
        for (let i = 0; i < me.years.length; i++) {
          if (me.years[i].activeMenu === true) me.years[i].activeMenu = false
        }
      },
      clearMonths() {
        let me = this
        for (let i = 0; i < me.months.length; i++) {
          if (me.months[i].activeMenu === true) me.months[i].activeMenu = false
        }
      },
      clearTypes() {
        let me = this
        for (let i = 0; i < me.types.length; i++) {
          if (me.types[i].activeMenu === true) me.types[i].activeMenu = false
        }
      },
      resetTypes() {
        let me = this
        let monthData = me.activeMonthData
        if (monthData) {
          me.types = null
          me.currentPage = 1
          me.loadLegislations(monthData.item, monthData.ind)
        }
      },
      loadLegislations(item, ind, page = 1) {
        let me = this
        me.legislationIsLoading = true
        me.activeMonthData = {
          item: item,
          ind: ind
        }
        me.activeMonthName = item.title
        me.clearMonths()
        item.activeMenu = true
        me.items = null
        me.typeSelected = false

        let activeMonth = parseInt(ind) + 1
        const promisse = PortalApi.fetchSelectedLegislations(
          me.activeYear,
          activeMonth,
          page,
          me.perPage
        )
        promisse.then((items) => {
          me.items = items.legislations.data
          me.totalRows = items.legislations.total
          me.legislationIsLoading = false
          me.legislationsLoaded = true
          if (items.legislations.data.length) {
            me.loadTypes(items.types, false)
          }
        })
      },
      changePage() {
        let me = this
        let monthData = me.activeMonthData
        if (monthData) {
          if (me.typeSelected) {
            me.loadType(me.activeTypeData, false, me.currentPage)
          } else {
            me.loadLegislations(monthData.item, monthData.ind, me.currentPage)
          }
        }
      },
      viewLegislation(legislationId, page = 1) {
        if (page == null) {
          page = 1
        }
        return (
          axios.defaults.baseURL +
          '/editions/viewPdf/' +
          legislationId +
          '#page=' +
          page
        )
      },
      downloadLegislation(legislationId) {
        return axios.defaults.baseURL + '/editions/downloadPdf/' + legislationId
      }
    },
    filters: {
      formatDate: function (value) {
        if (value) {
          return moment.utc(String(value)).format('LL')
        }
        return '-'
      },
      formatEpigrafe: function (value) {
        if (value) {
          return value
        }
        return '-'
      },
      formatViews: function (value) {
        if (!value) {
          return '0'
        }
      }
    }
  }
</script>

<style lang="scss">
  @import '../assets/scss/estilos.scss';
  #legislations-page {
    h4 {
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 1.2rem;
    }
    table {
      font-size: 14px;
      font-weight: 300;
      a {
        margin-right: 10px;
        color: #000;
        &:last-child {
          margin-right: 0;
        }
        &:hover {
          color: $corPrimariaClara;
        }
      }
      thead {
        th {
          border-bottom: 2px solid $corPrimaria;
          border-top: none;
        }
      }
      tbody {
        td {
          border-right: 1px solid #ddd;
          &:last-child {
            border-right: none;
          }
        }
      }
    }
    #tableLegislations {
      th.colEpigrafe {
        width: 67%;
      }
    }
  }
  .tituloIntro {
    margin: auto;
  }
  #arvore {
    width: 100%;
    text-align: center;
  }
  #decades-row,
  #years-row,
  #months-row,
  #types-row {
    width: 100%;
  }
  #decades,
  #years,
  #months,
  #types {
    height: auto;
    display: flex;
    justify-content: space-between;
  }
  #types {
    justify-content: center;
  }
  #decades > div,
  #years > div,
  #months > div,
  #types > div {
    margin: 1.5rem 0.2rem;
  }
  #decades-row,
  #months-row {
    background-color: #f0f0f0;
  }
  #years-row,
  #types-row {
    background-color: #fafafa;
  }
  .message {
    width: 100%;
    padding: 1.5rem 0.2rem;
    border-top: dashed 1px #ccc;
    text-align: center;
    display: block;
    strong {
      font-size: 0.95rem;
      line-height: 1.3rem;
      vertical-align: middle;
    }
  }
  .tipo-legislations {
    width: 100%;
    padding: 1rem 0.2rem 1rem 0;
    border-top: dashed 1px #ccc;
    border-bottom: solid 1px #dedede;
    display: block;
    * {
      font-size: 0.95rem;
      line-height: 1.3rem;
      vertical-align: middle;
    }
  }
  button.menu-active {
    background: $corPrimaria;
    color: white;
    border-radius: 3px;
    &:hover {
      background: $corPrimaria;
      color: white;
    }
  }
  /* Media Queries */
  /* xs and sm */
  @media (max-width: 767.98px) {
    #decades,
    #years {
      margin-bottom: 1rem;
      padding-bottom: 1rem;
      border-bottom: 1px dashed #aaa;
    }
    #decades,
    #years,
    #months {
      height: auto;
      width: 100%;
      display: inline-block;
    }
    #decades > div,
    #years > div,
    #months > div {
      margin: 0.75rem 0rem;
    }
    .periodButton {
      width: 90%;
    }
    #editions-page {
      table {
        a {
          margin-right: 3px;
          svg {
            width: 16px !important;
            height: 16px !important;
          }
        }
      }
    }
  }
  /* Tablets */
  /* iPad */
  @media (min-width: 768px) and (max-width: 991.98px) {
    #decades > div,
    #years > div {
      margin: 1.5rem 0.2rem;
    }
    #decades > div .btn,
    #years > div .btn {
      padding: 0.375rem 0.75rem;
    }
    #months > div {
      margin: 1.5rem 0.15rem;
    }
    #months > div .btn {
      padding: 0.375rem 0.15rem;
    }
    #editions-page {
      table {
        a {
          margin-right: 4px;
          svg {
            width: 15px !important;
            height: 15px !important;
          }
        }
      }
    }
  }
  /* iPad Pro */
  @media (min-width: 992px) and (max-width: 1024.98px) {
    #months > div .btn {
      padding: 0.375rem 0.75rem;
    }
  }
  /* xs */
  @media (max-width: 355px) {
    #editions-page {
      table {
        font-size: 12px;
        th,
        td {
          padding: 0.25rem;
        }
        a {
          margin-right: 2px;
          svg {
            width: 14px !important;
            height: 14px !important;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Legislacoes.vue